import { render, staticRenderFns } from "./MyFees.vue?vue&type=template&id=42c24172"
import script from "./MyFees.vue?vue&type=script&lang=js"
export * from "./MyFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42c24172')) {
      api.createRecord('42c24172', component.options)
    } else {
      api.reload('42c24172', component.options)
    }
    module.hot.accept("./MyFees.vue?vue&type=template&id=42c24172", function () {
      api.rerender('42c24172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/financial/fees/MyFees.vue"
export default component.exports